module.exports = __webpack_public_path__ + "static/img/indicator_light05.1b1feb3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/indicator_light05.gif
// module id = VE0T
// module chunks = 1